import { AddToCart } from "./AddToCart";

export function Footer() {
  return (
    <footer className="drop-shadow-top flex w-full flex-col items-center gap-4 rounded-t-xl bg-white p-4 lg:flex-row xl:px-8">
      <div className="flex flex-1 flex-col items-center gap-2 lg:flex-row"></div>

      <AddToCart />
    </footer>
  );
}
